import { SetNewPasswordForm } from '@/components/auth/setNewPasswordForm';
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { routes } from '@/types/routes';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_auth/(first-login)/set-new-password')({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    if (!context.auth.username || !context.auth.loginSession) {
      redirect({
        to: routes.firstTimeLogin,
        replace: true,
        throw: true,
      });
    }
  },
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('setNewPassword.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          { t('setNewPassword.description', { ns: 'auth' }) }
        </CardDescription>
      </CardHeader>

      <CardContent className="pt-space-lg">
        <SetNewPasswordForm />
      </CardContent>
    </>
  );
}
